import type { PaginationPropertiesProps } from 'bundles/seo/CourseraMetatagsV2Types';
import { FIRST_PAGE_NUMBER } from 'bundles/shared-articles/constants';
import { isValidPageNumber } from 'bundles/shared-articles/utils';

const addPageParamToUrl = (pageNumber: number, url: string): string => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.append('page', pageNumber.toString());
  return parsedUrl.toString();
};

const removePageParamFromUrl = (url: string): string => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.delete('page');
  return parsedUrl.toString();
};

export const generatePaginationProperties = ({
  pageCount,
  pageUrl,
  currentPageNumber,
}: {
  pageCount: number;
  pageUrl: string;
  currentPageNumber: number;
}): PaginationPropertiesProps | undefined => {
  if (!isValidPageNumber(currentPageNumber, pageCount)) return undefined;

  const baseUrl = removePageParamFromUrl(pageUrl);

  const canonicalLinkHrefOverride =
    currentPageNumber !== FIRST_PAGE_NUMBER ? addPageParamToUrl(currentPageNumber, baseUrl) : baseUrl;

  const prevPageNumber = currentPageNumber - 1;
  const nextPageNumber = currentPageNumber + 1;

  let absolutePrevPageHref;
  let absoluteNextPageHref;

  if (currentPageNumber > 1) {
    absolutePrevPageHref = prevPageNumber !== FIRST_PAGE_NUMBER ? addPageParamToUrl(prevPageNumber, baseUrl) : baseUrl;
  }
  if (nextPageNumber < pageCount) {
    absoluteNextPageHref = addPageParamToUrl(nextPageNumber, baseUrl);
  }

  return {
    canonicalLinkHrefOverride,
    absolutePrevPageHref,
    absoluteNextPageHref,
  };
};
